import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { Search } from '@saucelabs/ds-inputs';

import constants from '../constants';
import actions from '../actions';

const FilesSearch: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();

  const fetchFilesDebounced = useMemo(() => (
    debounce((searchQuery: string) => {
      void dispatch(actions.fetchAppStorageFiles({
        searchQuery,
        paginationPage: 1,
      }));
    }, constants.SEARCH_FILES_DEBOUNCE_THRESHOLD_MS)
  ), [dispatch]);

  return (
    <div className="max-w-39.75 mt-1.5 mb-3">
      <Search
        defaultValue=""
        onChange={fetchFilesDebounced}
      />
    </div>
  );
};

FilesSearch.displayName = 'SwitchAppVersionFilesSearch';

export default FilesSearch;
